import { logError } from '../sentry';
import { track } from './index';

/**
 * Flag track manually via bridge for android | iOS
 * @param {object} flag
 */
function flagTracker(flag) {
  try {
    if (typeof flag !== 'object' || flag === null) {
      throw new Error('Invalid flag object provided');
    }
    if (flag?.trackInfo?.flagType === 'abntest') {
      const payload = {
        abTestingCampaign: 'landing-items',
        abTestingVariation: flag?.variation,
      };
      track('abTesting', payload);
    }
  } catch (error) {
    logError('[TRACKING_FLAG_FORCE_WEBVIEW]', error);
  }
}

export default flagTracker;
